import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';
import { StorageService } from '@core/services/storage.service';

@Injectable()
export class AdtagService {
  public adtag?: string;

  @Inject(forwardRef(() => StorageService))
  public storageService!: StorageService;

  public setAdtag(adtag: string) {
    if (adtag) {
      this.adtag = adtag;
      this.storageService.setAdtag(adtag);
    } else {
      // 如果URL上没有adtag参数，就尝试从localStorage中取
      const localTag = this.storageService.getAdtag();
      if (localTag) {
        this.adtag = localTag;
      }
    }
  }

  public removeAdtag() {
    this.adtag = void 0;
    this.storageService.removeAdtag();
  }
}
